import { Component } from '@angular/core';

import { AffordabilityResultsDto } from '../../../models/dto/affordability-results-dto.model';
import { BaseConfirmationDialogComponent } from '../base-confirmation-dialog.component';

@Component({
  selector: 'boi-affordability-results-dialog',
  templateUrl: './affordability-results-dialog.component.html',
  styleUrls: ['./affordability-results-dialog.component.scss']
})
export class AffordabilityResultsDialogComponent extends BaseConfirmationDialogComponent<AffordabilityResultsDto> {}
